@let isMobileView = isMobileView$ | async;
@let currentLang = translateChanges$ | async;
<ion-header class="custom-header">
    <ion-toolbar class="custom-toolbar">
        <ion-title>
            <div class="flex justify-between items-center container">
                <a [routerLink]="['/']">
                    @if (currentLang) {
                        <ion-icon
                            [src]="'assets/svg/logo-' + currentLang + '.svg'"
                            class="logo-icon desktop:w-118 desktop:h-56 w-68 h-32"
                            color="dark"
                        ></ion-icon>
                    }
                </a>

                <div class="flex items-center">
                    <ncodp-lang-control class="desktop:mr-30 mr-15"></ncodp-lang-control>

                    @if (isMobileView) {
                        <ion-button
                            (click)="toggleAccessibilityPanel()"
                            [title]="'accessibility.button-title' | translate"
                            class="btn icon-only"
                            fill="clear"
                            size="small"
                        >
                            <ion-icon class="w-18 h-18" slot="start" src="assets/svg/visible.svg"></ion-icon>
                        </ion-button>
                        <ion-button
                            [disabled]="isLoadingExport()"
                            class="btn icon-only"
                            expand="full"
                            fill="clear"
                            (click)="downloadCatalog()"
                        >
                            <div class="flex items-center">
                                @if (isLoadingExport()) {
                                    <ion-spinner class="btn-spinner" name="lines"></ion-spinner>
                                } @else {
                                    <ion-icon [src]="'assets/svg/download.svg'" class="w-24 h-24" slot="start"></ion-icon>
                                }
                            </div>
                        </ion-button>
                    } @else {
                        <span class="mr-12">
                            <ion-button
                                (click)="toggleAccessibilityPanel()"
                                [title]="'accessibility.button-title' | translate"
                                class="btn accessibility-btn"
                                fill="clear"
                                size="small"
                            >
                                <ion-icon class="mr-12 w-18 h-18" slot="start" src="assets/svg/visible.svg"></ion-icon>
                                <span class="accessibility-text">{{ 'accessibility.button-title' | translate }}</span>
                            </ion-button>
                        </span>
                        <ion-button
                            [disabled]="isLoadingExport()"
                            class="btn button-small btn-outline-blue"
                            expand="full"
                            fill="clear"
                            (click)="downloadCatalog()"
                        >
                            <div class="flex items-center">
                                @if (isLoadingExport()) {
                                    <ion-spinner class="btn-spinner mr-10" name="lines"></ion-spinner>
                                } @else {
                                    <ion-icon [src]="'assets/svg/download.svg'" class="w-24 h-24 mr-10" slot="start"></ion-icon>
                                }
                                <span>{{ 'common.download-catalog' | translate }}</span>
                            </div>
                        </ion-button>
                    }
                </div>
            </div>
        </ion-title>
    </ion-toolbar>
</ion-header>
